import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-upload-documents-support',
  templateUrl: './upload-documents-support.component.html',
  styleUrls: ['./upload-documents-support.component.css']
})
export class UploadDocumentsSupportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
